import { UserAuth } from "./context/AuthContext";
import { Link, useNavigate } from 'react-router-dom';
import AdminUploadFiles from './AdminUploadFiles';
import AdminDownloadFiles from './AdminDownloadFiles';
import Exercises from "./Exercises";
import Statistics from './Statistics';
import AudioCutter from './AudioCutter';
import { useState } from 'react';

function AdminPage({ initialSection }) {
    const {user, logout} = UserAuth();
    const navigate = useNavigate();
    const [mainContent, setMainContent] = useState(() => initialSection === 'audio' ? <AudioCutter /> : '');

    const adminUploadFiles = <AdminUploadFiles />
    const adminDownloadFiles = <AdminDownloadFiles />
    const statistics = <Statistics />
    const exercises = <Exercises />
    const audioCutter = <AudioCutter />

    const handleLogout = async () => {
        try {
            await logout()
            navigate('/')
        } catch (e) {
            console.log(e.message)
        }
    }

    return (
        <div className="relative">
            <div className="min-h-screen bg-fixed bg-center bg-cover" style={{ backgroundImage: "url('/images/inca-background.jpg')" }}>
            <div className="fixed top-0 left-0 w-full bg-white bg-opacity-50 backdrop-blur-md py-4 px-8 z-50">
                <div className="flex justify-between items-center">
                    <Link to='/' className='text-black text-2xl'>Admin's account</Link>
                    <div className="space-x-2">
                        <button onClick={() => setMainContent(audioCutter)} type="button" className="transition-all ease-in duration-75 text-purple-700 hover:text-white border border-purple-700 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-purple-400 dark:text-purple-400 dark:hover:text-white dark:hover:bg-purple-500 dark:focus:ring-purple-900">Обрезка аудио</button>
                        <button onClick={() => setMainContent(adminUploadFiles)} type="button" className="transition-all ease-in duration-75 text-purple-700 hover:text-white border border-purple-700 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-purple-400 dark:text-purple-400 dark:hover:text-white dark:hover:bg-purple-500 dark:focus:ring-purple-900">
                            Upload files
                        </button>
                        <button onClick={() => setMainContent(adminDownloadFiles)} type="button" className="transition-all ease-in duration-75 text-green-700 hover:text-white border border-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-green-400 dark:text-green-400 dark:hover:text-white dark:hover:bg-green-500 dark:focus:ring-green-900">
                            Download files
                        </button>
                        <button onClick={() => setMainContent(exercises)} type="button" className="transition-all ease-in duration-75 text-orange-700 hover:text-white border border-orange-700 hover:bg-orange-700 focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-orange-400 dark:text-orange-400 dark:hover:text-white dark:hover:bg-orange-500 dark:focus:ring-orange-900">
                            Exercises
                        </button>
                        <button onClick={() => setMainContent(statistics)} type="button" className="transition-all ease-in duration-75 text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-blue-400 dark:text-blue-400 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-900">
                        Statistics
                        </button>
                    </div>
                    <button onClick={handleLogout} className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-md font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-orange-400 to-red-400 group-hover:from-orange-400 group-hover:to-red-400 dark:text-white dark:hover:text-gray-900 focus:ring-4 focus:outline-none focus:ring-red-100 dark:focus:ring-red-400">
                    <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">Logout</span>
                    </button>
                </div>
            </div>
                {/* Добавляем полупрозрачный и заблюренный слой */}
                <div className="min-h-screen w-full bg-white bg-opacity-50 backdrop-blur-md flex flex-col justify-start items-center">
                    {mainContent}
                </div>
            </div>
        </div>
    )
}

export default AdminPage;